<template>
    <div class="">
        <loading-overlay :is-loading="showLoader" :full-page="true" />
        <div>
          <div class="text-lg font-extrabold text-grey-700">Your current plan: {{ planName }}</div>
          <gd-button
            size="auto"
            v-show="upgradeButtonUrl"
            class="p-4 mr-4 mt-4 font-medium"
            variant="outline"
            style="animation:2s ease 0s infinite normal none running pulse"
            @click="goToUpgradePage"
          >
            {{ upgrade_button_text_localized }}
          </gd-button>
        </div>
    </div>

</template>

<script>
import Auth from '@groovepages/gd-lib/auth';
import api from '@groovepages/gd-lib/api';
import GdButton from './Button';
import mixins from '../mixins';
import LoadingOverlay from './LoadingOverlay';

export default {
  name: 'AccountBilling',
  mixins: [mixins],
  components: {
    GdButton,
    LoadingOverlay
  },
  data() {
    return {
      upgradeButtonUrl: "",
      showDaysLeftInPlan: "",
      planEndInDays: "",
      planName: "",
      upgrade_button_text_localized: "",
      showLoader: false,
    };
  },
  async created() {
    this.showLoader = true;
    let self = this

    await api
      .get(`${window.gdEnv.VUE_APP_API_URL}/groovesell/show-member-upgrade-ad/${Auth.authenticatedUser().id}`)
      .then((data) => {
        this.upgradeButtonUrl = data.upgrade_button_url;
        this.showDaysLeftInPlan = data.show_days_left_in_plan;
        this.planEndInDays = data.plan_end_in_days;
        this.planName = data.plan_name;
        this.upgrade_button_text_localized = data.upgrade_button_text[this.$root.$i18n.locale ?? 'en'];
        self.showLoader = false;
      })
      .catch(() => {});
  },
  methods: {
    goToUpgradePage() {
      window.open(this.upgradeButtonUrl, '_blank');
    },
  }
};
</script>

<style lang="scss">
@keyframes pulse {
  0% {
    transform: scale(.95);
  }
  70% {
    transform: scale(1);
  }
  100% {
    transform: scale(.95);
  }
}
</style>